import { Component, ElementRef, EventEmitter, HostListener, Input, Output, inject, signal } from '@angular/core';

export interface ItemMenuAcao {
  label: string;
  aoClicar: () => void;
}

@Component({
  selector: 'app-tabela-acao',
  standalone: true,
  imports: [],
  templateUrl: './tabela-acao.component.html',
  styleUrl: './tabela-acao.component.css'
})
export class TabelaAcaoComponent {
  @Input() icone!: string;
  @Input() titulo?: string;
  @Input() disabled = false;
  @Input() isMenu = false;
  @Input() itensMenu: ItemMenuAcao[] = [];

  @Output() aoClicar = new EventEmitter<void>();

  aberto = signal(false);
  posicaoPainel = signal({ top: 0, left: 0 });

  private readonly elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  aoClicarFora(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.aberto.set(false);
    }
  }

  @HostListener('window:scroll', ['$event'])
  @HostListener('window:resize')
  aoRolarOuRedimensionar() {
    if (this.aberto()) {
      this.aberto.set(false);
    }
  }

  clicar(origem?: HTMLElement) {
    if (this.disabled) {
      return;
    }
    if (this.isMenu) {
      if (!this.aberto() && origem) {
        const rect = origem.getBoundingClientRect();
        this.posicaoPainel.set({ top: rect.bottom + 4, left: rect.left });
      }
      this.aberto.update(v => !v);
      return;
    }
    this.aoClicar.emit();
  }

  clicarItemMenu(item: ItemMenuAcao) {
    this.aberto.set(false);
    item.aoClicar();
  }
}
